import { Card, Button } from '@nearst/ui';
import { Input, InputGroup } from '@nearst/ui';
import { StepNumber } from './StepNumber';
import { GooglePlacesAutocompleteInput } from './GooglePlacesAutocompleteInput';
import styles from '../UnifyOnboarding.module.scss';

export const BusinessDetails = ({
	isCompleted,
	isExpanded,
	selectedPlace,
	addressDetails,
	formData,
	loading,
	validationErrors,
	onPlaceSelect,
	onFormChange,
	onFieldBlur,
	onSubmit,
	onEdit,
	onChangeStore,
	isSignedIn,
	showPassword,
	authError,
	// onGoogleSignUp, // Google Auth disabled
	onEmailBlur,
	isAuthenticating
}) => {
	// Check if form is valid for submission
	const isFormValid =
		addressDetails?.postcode &&
		formData.name?.trim() &&
		formData.email?.trim() &&
		(isSignedIn || (formData.password && formData.password.length >= 8));
	return (
		<Card className={styles.stepCard}>
			<div className={styles.stepHeader}>
				<StepNumber number={1} isActive={!isCompleted} isCompleted={isCompleted} />
				<h3 className={styles.stepTitle}>Complete your business and contact details</h3>
			</div>

			{!isCompleted ? (
				<div className={styles.stepContent}>
					<InputGroup label="Store name">
						<GooglePlacesAutocompleteInput onPlaceSelect={onPlaceSelect} selectedPlace={selectedPlace} />
					</InputGroup>

					{isExpanded && (
						<div className={styles.expandedForm} data-cy="business-details-expanded-form">
							<div className={styles.addressBlock}>
								<h4>Store address</h4>
								{addressDetails && (
									<div className={styles.addressDisplay} data-cy="address-display">
										<p data-cy="shop-name-display">
											<strong>{addressDetails.name}</strong>
										</p>
										<p data-cy="address-line1-display">{addressDetails.addressLine1}</p>
										{addressDetails.addressLine2 && (
											<p data-cy="address-line2-display">{addressDetails.addressLine2}</p>
										)}
										<p data-cy="city-display">{addressDetails.city}</p>
										<p data-cy="postcode-display">{addressDetails.postcode}</p>
										<p data-cy="country-display">{addressDetails.country}</p>
										<button className={styles.linkButton} data-cy="change-store-button" onClick={onChangeStore}>
											Change store
										</button>
									</div>
								)}
							</div>

							{/* Google Auth sign-up disabled */}
							{/* {!isSignedIn && (
								<div className={styles.authSection}>
									<h4>Contact details</h4>
									<Button
										onClick={onGoogleSignUp}
										disabled={isAuthenticating || loading}
										data-cy="google-signup-button"
										className={styles.googleButton}
									>
										{isAuthenticating ? 'Signing up...' : 'Sign up with Google'}
									</Button>

									<div className={styles.divider}>
										<span>OR</span>
									</div>
								</div>
							)} */}

							{!isSignedIn && (
								<div className={styles.authSection}>
									<h4>Contact details</h4>
								</div>
							)}

							<InputGroup label="Full name" requiredField>
								<Input
									data-cy="contact-name-input"
									value={formData.name}
									onChange={(e) => onFormChange('name', e.target.value)}
									onBlur={() => onFieldBlur('name')}
									disabled={loading || isAuthenticating}
								/>
							</InputGroup>

							<InputGroup label="Email address" requiredField>
								<Input
									data-cy="contact-email-input"
									type="email"
									value={formData.email}
									onChange={(e) => onFormChange('email', e.target.value)}
									onBlur={onEmailBlur}
									disabled={loading || isAuthenticating}
								/>
							</InputGroup>

							{showPassword && !isSignedIn && (
								<InputGroup label="Create password" requiredField>
									<Input
										data-cy="password-input"
										type="password"
										value={formData.password || ''}
										onChange={(e) => onFormChange('password', e.target.value)}
										onBlur={() => onFieldBlur('password')}
										disabled={loading || isAuthenticating}
									/>
									<p className={styles.passwordHint}>At least 8 characters</p>
								</InputGroup>
							)}

							{authError && (
								<div className={styles.errorMessage} data-cy="auth-error">
									{authError}
								</div>
							)}

							{validationErrors && Object.keys(validationErrors).length > 0 && (
								<div className={styles.validationErrors} data-cy="validation-errors">
									{Object.values(validationErrors).map((message, index) => (
										<div key={index}>{message}</div>
									))}
								</div>
							)}
							<div id="clerk-captcha" />
							<Button
								primary
								onClick={onSubmit}
								disabled={!isFormValid || loading || isAuthenticating}
								data-cy="submit-button"
								className={styles.submitButton}
							>
								{loading ? 'Creating shop...' : isAuthenticating ? 'Authenticating...' : 'Get started'}
							</Button>

							<p className={styles.termsText}>
								By registering, you agree to the{' '}
								<a href="https://www.near.st/legal/retailer-terms" target="_blank" rel="noreferrer">
									Retailer Terms & Conditions
								</a>
								.
							</p>
						</div>
					)}
				</div>
			) : (
				<div className={styles.stepContent}>
					<div className={styles.completedInfo}>
						<p>
							<strong>{addressDetails?.name || 'Store name'}</strong>
						</p>
						<p className={styles.helperText}>{formData.name}</p>
						<button className={styles.linkButton} onClick={onEdit}>
							Edit details
						</button>
					</div>
				</div>
			)}
		</Card>
	);
};
